"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineObject9ToJSON = exports.InlineObject9FromJSONTyped = exports.InlineObject9FromJSON = void 0;
var _1 = require("./");
function InlineObject9FromJSON(json) {
    return InlineObject9FromJSONTyped(json, false);
}
exports.InlineObject9FromJSON = InlineObject9FromJSON;
function InlineObject9FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'socketId': json['socketId'],
        'channelId': json['channelId'],
        'messages': (json['messages'].map(_1.DiscordRelayMessageHistoryMessagesFromJSON)),
        'botToken': json['botToken'],
    };
}
exports.InlineObject9FromJSONTyped = InlineObject9FromJSONTyped;
function InlineObject9ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'socketId': value.socketId,
        'channelId': value.channelId,
        'messages': (value.messages.map(_1.DiscordRelayMessageHistoryMessagesToJSON)),
        'botToken': value.botToken,
    };
}
exports.InlineObject9ToJSON = InlineObject9ToJSON;
